import { Palette, ShoppingCart, Search, Smartphone, Rocket, LineChart, Coffee, Scale, Dumbbell, Cake, Wind, Leaf } from "lucide-react";

export const BRAND = {
  name: "Titan Web Solutions",
  tagline: "Powerful Websites. Real Results.",
  logo: "https://customer-assets-4nw71qhi.emergentagent.net/job_titan-convert-pro/artifacts/fc78nb9d_Titan%20logo.PNG",
  email: "info@titanwebsolutions.net",
  phone: "+1 (415) 555-0142",
  location: "Nashville, TN",
};

export const NAV_LINKS = [
  { label: "Services", href: "#services" },
  { label: "Portfolio", href: "/portfolio" },
  { label: "Pricing", href: "#pricing" },
  { label: "About", href: "#about" },
  { label: "Founder", href: "/founder" },
];

export const IMAGES = {
  heroBg:
    "https://images.unsplash.com/photo-1579548122080-c35fd6820ecb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxkYXJrJTIwYWJzdHJhY3QlMjB0ZWNoJTIwYmx1ZXxlbnwwfHx8fDE3ODQ4NDc1MTh8MA&ixlib=rb-4.1.0&q=85",
  work1:
    "https://images.unsplash.com/photo-1542744095-291d1f67b221?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHw0fHxsYXB0b3AlMjB3ZWJzaXRlJTIwZGVzaWdufGVufDB8fHx8MTc4NDg0NzUxOHww&ixlib=rb-4.1.0&q=85",
  work2:
    "https://images.unsplash.com/photo-1507238691740-187a5b1d37b8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwyfHxsYXB0b3AlMjB3ZWJzaXRlJTIwZGVzaWdufGVufDB8fHx8MTc4NDg0NzUxOHww&ixlib=rb-4.1.0&q=85",
  office:
    "https://images.pexels.com/photos/12902992/pexels-photo-12902992.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  owner:
    "https://images.unsplash.com/photo-1753351052363-53ce102830eb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwzfHxzbWFsbCUyMGJ1c2luZXNzJTIwb3duZXIlMjBzaG9wfGVufDB8fHx8MTc4NDg0NzUxOHww&ixlib=rb-4.1.0&q=85",
  work3:
    "https://images.unsplash.com/photo-1497366754035-f200968a6e72?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  work4:
    "https://images.unsplash.com/photo-1540555700478-4be289fbecef?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const SERVICES = [
  {
    icon: Palette,
    title: "Web Design",
    desc: "Custom, conversion-first websites crafted to make small businesses look enterprise-grade.",
    tag: "Most popular",
  },
  {
    icon: ShoppingCart,
    title: "E-Commerce",
    desc: "Fast, frictionless online stores that turn browsers into paying customers.",
  },
  {
    icon: Search,
    title: "SEO Optimization",
    desc: "Rank higher, get found, and pull in qualified local traffic on autopilot.",
  },
  {
    icon: Smartphone,
    title: "Mobile-First Builds",
    desc: "Pixel-perfect experiences that feel native on every phone, tablet and screen.",
  },
  {
    icon: Rocket,
    title: "Brand & Identity",
    desc: "Logos, systems and messaging that make your business impossible to forget.",
  },
  {
    icon: LineChart,
    title: "Growth & Analytics",
    desc: "Data, funnels and A/B testing to squeeze more revenue from every visitor.",
  },
];

export const PROCESS = [
  {
    no: "01",
    title: "Discover",
    desc: "We dig into your business, goals and customers to map the fastest path to revenue.",
  },
  {
    no: "02",
    title: "Design",
    desc: "We craft a bold, on-brand interface engineered around a single outcome: conversions.",
  },
  {
    no: "03",
    title: "Develop",
    desc: "We build blazing-fast, responsive sites with clean code and airtight performance.",
  },
  {
    no: "04",
    title: "Grow",
    desc: "We launch, measure and optimize — turning your website into a 24/7 sales engine.",
  },
];

export const PROJECTS = [
  {
    slug: "harborline-coffee",
    title: "Harborline Coffee",
    category: "E-Commerce · Branding",
    image: IMAGES.work1,
    result: "+180% online orders",
    span: "md:col-span-7",
  },
  {
    slug: "nolan-reyes-law",
    title: "Nolan & Reyes Law",
    category: "Web Design · SEO",
    image: IMAGES.work2,
    result: "3.2x qualified leads",
    span: "md:col-span-5",
  },
  {
    slug: "verde-fitness",
    title: "Verde Fitness Studio",
    category: "Web Design · Booking",
    image: IMAGES.office,
    result: "+64% memberships",
    span: "md:col-span-5",
  },
  {
    slug: "maple-street-bakery",
    title: "Maple Street Bakery",
    category: "E-Commerce · Growth",
    image: IMAGES.owner,
    result: "$120k first quarter",
    span: "md:col-span-7",
  },
  {
    slug: "northwind-consulting",
    title: "Northwind Consulting",
    category: "Web Design · Lead Gen",
    image: IMAGES.work3,
    result: "5.1x demo requests",
    span: "md:col-span-6",
  },
  {
    slug: "blue-fern-spa",
    title: "Blue Fern Spa",
    category: "Web Design · Booking",
    image: IMAGES.work4,
    result: "+92% bookings",
    span: "md:col-span-6",
  },
];

export const CASE_STUDIES = {
  "harborline-coffee": {
    title: "Harborline Coffee",
    category: "E-Commerce · Branding",
    image: IMAGES.work1,
    intro:
      "A beloved neighborhood roaster with lines out the door — and a website nobody could order from. We rebuilt Harborline into a fast, mobile-first store that sells beans while they sleep.",
    challenge:
      "Their old site was a static brochure. Loyal customers had no way to reorder their favorite roast, and wholesale enquiries were lost in a generic inbox.",
    solution:
      "We designed a bold, photography-led storefront with one-tap reordering, subscription bundles, and a streamlined wholesale portal — all wrapped in a refreshed brand identity.",
    results: [
      { value: "+180%", label: "Online orders" },
      { value: "2.1s", label: "Load time" },
      { value: "34%", label: "Subscription rate" },
    ],
    quote: "They understood a small budget without ever making it look small.",
    author: "Marcus Lee, Founder",
  },
  "nolan-reyes-law": {
    title: "Nolan & Reyes Law",
    category: "Web Design · SEO",
    image: IMAGES.work2,
    intro:
      "A two-partner practice competing against firms ten times their size. We gave them a site that commands authority and a local SEO engine that fills their calendar.",
    challenge:
      "Invisible on Google, no clear path for prospective clients to book a consultation, and a design that undersold their expertise.",
    solution:
      "A refined, trust-forward redesign paired with technical + local SEO, structured case-result pages, and a frictionless consultation request flow.",
    results: [
      { value: "3.2x", label: "Qualified leads" },
      { value: "#1", label: "Local rankings" },
      { value: "+95%", label: "Organic traffic" },
    ],
    quote: "For the first time our website looks like the firm we actually are.",
    author: "Elena Reyes, Partner",
  },
  "verde-fitness": {
    title: "Verde Fitness Studio",
    category: "Web Design · Booking",
    image: IMAGES.office,
    intro:
      "A boutique studio drowning in DMs and phone tag. We built a website with class booking baked in — so members sign up themselves.",
    challenge:
      "Every class booking happened manually. Sign-ups stalled and the team burned hours on scheduling instead of coaching.",
    solution:
      "A high-energy site with live class schedules, self-serve booking, membership tiers, and automated reminders that cut no-shows.",
    results: [
      { value: "+64%", label: "New memberships" },
      { value: "-40%", label: "No-shows" },
      { value: "8 hrs", label: "Saved weekly" },
    ],
    quote: "Titan rebuilt our site and doubled our bookings in eight weeks.",
    author: "Dana Whitfield, Owner",
  },
  "maple-street-bakery": {
    title: "Maple Street Bakery",
    category: "E-Commerce · Growth",
    image: IMAGES.owner,
    intro:
      "A family bakery ready to ship nationwide. We turned their storefront charm into a scalable online business.",
    challenge:
      "Huge local love, zero online revenue, and no way to handle pre-orders for the holiday rush.",
    solution:
      "A warm, appetite-driven e-commerce build with pre-order scheduling, gift bundles, and a growth funnel powered by email capture and analytics.",
    results: [
      { value: "$120k", label: "First quarter" },
      { value: "12k", label: "Email subscribers" },
      { value: "4.9★", label: "Customer rating" },
    ],
    quote: "Our online orders have never been higher — it paid for itself fast.",
    author: "Priya Nadar, Co-owner",
  },
  "northwind-consulting": {
    title: "Northwind Consulting",
    category: "Web Design · Lead Gen",
    image: IMAGES.work3,
    intro:
      "A boutique B2B consultancy with a referral-only pipeline. We built a credibility-first site and a lead engine that opened a brand-new channel.",
    challenge:
      "All growth came from word of mouth. Their outdated site converted almost no inbound visitors into qualified demo requests.",
    solution:
      "A sharp, authority-driven redesign with case-result proof, a frictionless demo-request flow, and conversion tracking wired into their CRM.",
    results: [
      { value: "5.1x", label: "Demo requests" },
      { value: "+140%", label: "Time on site" },
      { value: "22%", label: "Form conversion" },
    ],
    quote: "For the first time, our website actually brings us business.",
    author: "Tom Okafor, Managing Partner",
  },
  "blue-fern-spa": {
    title: "Blue Fern Spa",
    category: "Web Design · Booking",
    image: IMAGES.work4,
    intro:
      "A serene day spa losing bookings to clunky phone scheduling. We designed a calm, sensory site with instant online booking.",
    challenge:
      "Guests couldn't book after hours, and the old site didn't capture the tranquil, premium feel of the space.",
    solution:
      "An immersive, soft-touch redesign with real-time appointment booking, gift cards, and membership packages that lifted repeat visits.",
    results: [
      { value: "+92%", label: "Online bookings" },
      { value: "+38%", label: "Repeat guests" },
      { value: "24/7", label: "Self-booking" },
    ],
    quote: "It feels like walking into the spa before you even arrive.",
    author: "Sofia Alvarez, Founder",
  },
};

export const CLIENTS = [
  { name: "Harborline", icon: Coffee },
  { name: "Nolan & Reyes", icon: Scale },
  { name: "Verde", icon: Dumbbell },
  { name: "Maple St.", icon: Cake },
  { name: "Northwind", icon: Wind },
  { name: "Blue Fern", icon: Leaf },
];

export const STATS = [
  { value: "120+", label: "Sites Shipped" },
  { value: "4.9/5", label: "Client Rating" },
  { value: "3.4x", label: "Avg. Conversion Lift" },
  { value: "9 yrs", label: "In Business" },
];

export const TESTIMONIALS = [
  {
    quote:
      "Titan rebuilt our site and doubled our bookings in eight weeks. It finally looks like the business we always knew we were.",
    name: "Dana Whitfield",
    role: "Owner, Verde Fitness Studio",
  },
  {
    quote:
      "They understood a small budget without ever making it look small. Our online orders have never been higher.",
    name: "Marcus Lee",
    role: "Founder, Harborline Coffee",
  },
];

